export enum DateTimeIntervals {
  Distance = 'distance',
  Relative = 'relative',
  DateTime = 'datetime'
}
